import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import TextInputWithEmoji from 'components/ReusableComponents/ManageHotel/TextInputWithEmoji'
import PropTypes from 'prop-types'

import styles from './EditStepDialog.module.scss'

function LandingContentStep({ landing, setLanding, hotelName, firstName }) {
  function updateField(field, value) {
    setLanding(current => ({
      ...current,
      [field]: value
    }))
  }

  function interpolatePreview(value) {
    return (value || '')
      .replace(/\{first\}/g, firstName || 'Joe')
      .replace(/\{hotel\}/g, hotelName || 'the hotel')
  }

  return (
    <div className={styles.landingStep}>
      <p className={styles.description}>
        Edit the Savibook landing page guests see when they open the link from this step.
        Changes are saved as a draft until you launch the campaign.
      </p>

      <TextInputWithEmoji
        label="Header"
        className={styles.textInput}
        value={landing?.header || ''}
        onValueChange={value => updateField('header', value)}
        maxLength={120}
      />

      <TextInputWithEmoji
        label="Body"
        className={styles.textInput}
        value={landing?.body || ''}
        onValueChange={value => updateField('body', value)}
        maxLength={500}
      />

      <TextInput
        label="Call to action"
        className={styles.textInput}
        value={landing?.cta || ''}
        onChange={e => updateField('cta', e.target.value)}
      />

      <div className={styles.landingSectionDivider}>Success screen</div>

      <TextInput
        label="Success title"
        className={styles.textInput}
        value={landing?.successTitle || ''}
        onChange={e => updateField('successTitle', e.target.value)}
      />

      <TextInputWithEmoji
        label="Success body"
        className={styles.textInput}
        value={landing?.successBody || ''}
        onValueChange={value => updateField('successBody', value)}
        maxLength={500}
      />

      <TextInputWithEmoji
        label="Success closing"
        className={styles.textInput}
        value={landing?.successClosing || ''}
        onValueChange={value => updateField('successClosing', value)}
        maxLength={200}
      />

      <div className={styles.landingPreviewHint}>
        Preview: {interpolatePreview(landing?.header || 'Header')}
      </div>
    </div>
  )
}

LandingContentStep.propTypes = {
  landing: PropTypes.shape({
    header: PropTypes.string,
    body: PropTypes.string,
    cta: PropTypes.string,
    successTitle: PropTypes.string,
    successBody: PropTypes.string,
    successClosing: PropTypes.string
  }).isRequired,
  setLanding: PropTypes.func.isRequired,
  hotelName: PropTypes.string,
  firstName: PropTypes.string
}

export default LandingContentStep
